import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_e5eaca89: FaireBrandEntity = {
  token: "b_e5eaca89",
  type: "brand",
  name: "Diana Kauffman Designs",
  avatarUrl:
    "https://cdn.faire.com/fastly/8e86857085cd807cb8a93ea48e53d1b4c38b62acbac2bae19d0b92f608f00164.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/4d6329619b60a820ce62adc4d1ab4a461dcc565b013089579d77bab96cf764ba.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8e86857085cd807cb8a93ea48e53d1b4c38b62acbac2bae19d0b92f608f00164.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4d6329619b60a820ce62adc4d1ab4a461dcc565b013089579d77bab96cf764ba.jpeg",
  location: "Sewickley, PA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 13,
  isInsider: true,
  description:
    "Handcrafted, strong, timeless. They’re words that not only describe Diana’s creations but the people who wear them. Her award-winning men’s and women’s jewelry line blends bold lines, spirited colors, quality materials and exceptional hand-craftsmanship into distinctive statement pieces.   Diana personally sources natural components from around the world, such as Italian leather and Portuguese cork that age with grace and beauty.  \n\nStrong yet lightweight, her bracelets, necklaces and earrings are available in multiple sizes to fit the wearer. Additionally, DKD jewelry is easy to put on and take off; making them versatile for on the go wear, everywhere. \n\nFounded in 2013, Diana Kauffman Designs can be found  in exclusive boutiques and galleries across the United States. ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:12.653Z",
    importedBy: "entity-db-cli",
  },
};
